export default __webpack_public_path__ + "static/images/efficient-overview.17895779.png";